<template>
  <div class="pb-12 mt-n2 poppins" style="background: #f7f7fa">
    <div class="px-1 px-sm-4">
      <div
        class="px-1 px-md-4 mb-2 d-flex flex-column flex-sm-row justify-content-center justify-content-md-end"
      >
        <div
          class="row justify-content-between align-items-center mt-6 mb-4 mb-sm-0"
        >
          <div class="col-12 col-md-auto ms-3">
            <h3 class="font-weight-bolder mb-1">Performance Dashboard</h3>
            <p class="text-dark-50 font-weight-bold mb-0">Home - Performance</p>
          </div>
        </div>

        <div class="d-flex align-items-center ps-2 ps-sm-0">
          <DashboardWarehouseSelect :updateData="loadInitialDataFromServer" />
        </div>
      </div>

      <div
        v-if="messages?.length"
        class="px-1 px-md-4 my-4 d-flex justify-content-center justify-content-md-end"
      >
        <div class="row align-items-center mt-1 px-2">
          <div
            v-for="message in messages"
            :key="message.value"
            class="d-flex justify-center flex-column py-3 ms-3"
          >
            <div
              class="alert-item pa-3 bg-hover-light-warning"
              @click="() => handlerFilter(message.filters)"
            >
              <span class="svg-icon">
                <v-icon size="18">mdi-comment-alert</v-icon>
              </span>
              <strong class="text-h5 font-weight-bolder text-dark-65"
                >{{ message.text }}:</strong
              >
              <strong class="text-h5 font-weight-bold text-dark-65">{{
                message.value
              }}</strong>
            </div>
          </div>

          <!--          <div-->
          <!--            v-for="message in messages"-->
          <!--            :key="message.value"-->
          <!--            class="d-flex justify-center flex-column pa-3 ms-3 border rounded-xl w-225px bg-white pa-4 px-6"-->
          <!--            :class="{-->
          <!--              'border-light-success': message.value === 0,-->
          <!--              'border-light-danger': message.value > 0,-->
          <!--            }"-->
          <!--          >-->

          <!--            <div class="mb-8 d-flex align-items-center justify-space-between">-->
          <!--              <span class="svg-icon m-0 danger caret">-->
          <!--                <v-icon-->
          <!--                  size="30"-->
          <!--                  :class="{-->
          <!--                    'light-green&#45;&#45;text text&#45;&#45;darken-1': message.value === 0,-->
          <!--                    'text-danger': message.value > 0,-->
          <!--                  }"-->
          <!--                  >mdi-bell-ring-outline</v-icon-->
          <!--                >-->
          <!--              </span>-->

          <!--              <h1 class="font-weight-bold mb-0 text-dark-65 display5">-->
          <!--                {{ message.value }}-->
          <!--              </h1>-->
          <!--            </div>-->

          <!--            <h4 class="font-weight-bolder text-dark-50 text-center">-->
          <!--              {{ message.text }}-->
          <!--            </h4>-->

          <!--            <h3-->
          <!--              class="font-weight-bold"-->
          <!--              :class="{-->
          <!--                'light-green&#45;&#45;text text&#45;&#45;darken-1': message.value === 0,-->
          <!--                'text-danger': message.value > 0,-->
          <!--              }"-->
          <!--            >-->
          <!--              {{ message.text }} :&nbsp; {{ message.value }}-->
          <!--            </h3>-->

          <!--          </div>-->
        </div>
      </div>

      <DashboardOperationGroup
        v-if="serverData?.length"
        :serverData="serverData"
      />
      <v-skeleton-loader
        class="mt-10 px-6"
        v-else
        type="card"
      ></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import DashboardOperationGroup from "@/own/components/dashboard/DashboardOperationGroupNew.vue";
import DashboardWarehouseSelect from "@/own/components/dashboard/DashboardWarehouseSelect.vue";
import {
  SET_WAREHOUSE,
  SET_WAREHOUSES_LIST,
} from "@/core/services/store/auth.module";
import { SET_FILTERS_DATA } from "@/core/services/store/filter.module";
import {
  SET_TABLE_FILTER,
  UPDATE_TABLE_STRUCTURE,
  UPDATE_TABLE_DATA,
} from "@/core/services/store/orders.module";

export default {
  name: "DashboardOperation",
  components: { DashboardOperationGroup, DashboardWarehouseSelect },
  data: () => ({
    serverData: [],
    messages: [],
    intervalId: null,
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.loadInitialDataFromServer();
    this.startAutoRefresh();
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
  methods: {
    handlerFilter(filters) {
      if (Array.isArray(filters)) return;

      this.$store.commit(SET_PAGE_LOADING, true);
      let readyFilter = [];

      Object.entries(filters).forEach((filter) => {
        if (
          filter[0] != null &&
          filter[1] != null &&
          filter[1] != undefined &&
          filter[1].length !== 0
        ) {
          if (filter[0] !== "date_range") {
            readyFilter.push({ name: filter[0], value: filter[1] });
          } else if (filter[0] === "date_range") {
            readyFilter.push(
              {
                name: "date_range.date",
                value: [filter[1].from, filter[1].to],
              },
              { name: "date_range.select", value: filter[1].type }
            );
          }
        }
      });

      this.$store.commit(SET_FILTERS_DATA, readyFilter);

      this.setOrdersTableFiltersValues(readyFilter);
    },
    async setOrdersTableFiltersValues(val) {
      this.$store.commit(SET_TABLE_FILTER, val);

      this.updateOrdersTable().then(async () => {
        await this.$router.push({
          name: "fulfillment.orders",
          params: { isFromDashboard: true },
        });
      });
    },
    async updateOrdersTable() {
      const tableStructurePromise = this.$store.dispatch(
        UPDATE_TABLE_STRUCTURE,
        {}
      );
      const tableDataPromise = this.$store.dispatch(
        UPDATE_TABLE_DATA,
        this.$store.getters.getORDERSTableState
      );

      await Promise.all([tableStructurePromise, tableDataPromise]);
      this.$store.commit(SET_PAGE_LOADING, false);
    },
    startAutoRefresh() {
      this.intervalId = setInterval(() => {
        this.loadInitialDataFromServer(
          true,
          this.$store.getters.getSelectedWarehouse
        );
      }, 300000);
    },
    stopAutoRefresh() {
      clearInterval(this.intervalId);
    },
    loadInitialDataFromServer(forAutoRefresh = false, param = null) {
      this.$store.commit(SET_PAGE_LOADING, true);
      let filterData = {
        date_range_type: "custom",
        date_range: ["2021-01-15", "2021-02-14"],
      };

      let url = param
        ? `/dashboards/dashboardOperation?warehouse_id=${param}`
        : "/dashboards/dashboardOperation";

      ApiService.post(url, filterData)
        .then((response) => {
          // console.log(response.data);
          // this.serverData = response.data;
          this.serverData = response.data.data[0];
          this.messages = response.data.messages;
          if (!forAutoRefresh) {
            this.$store.commit(
              SET_WAREHOUSE,
              response.data.selected_warehouse_id
            );
            this.$store.commit(SET_WAREHOUSES_LIST, response.data.warehouses);
          }
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
};
</script>

<style scoped>
.alert-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background-color: #fffbe6;
  border-left: 4px solid #ffc107;
  border-radius: 4px;
  margin-bottom: 8px;
}
.svg-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
